import type { ReactElement } from 'react';

import type { TSocialMediaLink } from '@audacy-clients/core/atoms/wrappers/types';
import ContactSheetPhoneNumber from './PhoneNumber';
import ContactSheetSocialMediaLinks from './SocialMediaLinks';
import ContactSheetUtterancePhrase from './UtterancePhrase';
import styles from './styles';

export type IContactInformation = {
  phoneNumber?: string;
  socialMediaLinks?: Array<TSocialMediaLink>;
  utterancePhrase?: string | null;
};

type TContactSheetProps = {
  contactInformation: IContactInformation;
};

const ContactSheetDivider = () => <div css={styles.divider} />;
const addContactSheetDividerBetweenElements = (nodesToDisplay: Array<ReactElement>) => {
  return nodesToDisplay.flatMap((node, index, arr) =>
    index < arr.length - 1 ? [node, <ContactSheetDivider key={`${node.key} Divider`} />] : [node],
  );
};

const ContactSheet = ({ contactInformation }: TContactSheetProps): ReactElement => {
  const contactInformationNodes: Array<ReactElement> = [];
  if (
    Array.isArray(contactInformation.socialMediaLinks) &&
    contactInformation.socialMediaLinks.length > 0
  ) {
    contactInformationNodes.push(
      <ContactSheetSocialMediaLinks socialMediaLinks={contactInformation.socialMediaLinks} />,
    );
  }

  if (contactInformation.utterancePhrase) {
    contactInformationNodes.push(
      <ContactSheetUtterancePhrase utterancePhrase={contactInformation.utterancePhrase} />,
    );
  }

  if (contactInformation.phoneNumber) {
    contactInformationNodes.push(
      <ContactSheetPhoneNumber phoneNumber={contactInformation.phoneNumber} />,
    );
  }

  const contactInformationToRender = addContactSheetDividerBetweenElements(contactInformationNodes);
  return <div css={styles.contactSheetContainer}>{contactInformationToRender}</div>;
};

export default ContactSheet;
